// const index = () => import('./the-site')
const index = () => import('./the-site')

export default [
  {
    path: '/',
    name: 'index',
    component: index
  }
]



// WEBPACK FOOTER //
// ./src/components/site/routes.js